// #735: Einstiegspunkt /profile?tab=notifications.
//
// Warum das hier steht und nicht als generischer Tab-Routing-Mechanismus: der Parameter hat genau
// EINEN Erzeuger — den Server. Jede Benachrichtigungsmail verlinkt die Einstellungen im Footer, und
// Mailprogramme bieten denselben Link ueber den List-Unsubscribe-Header an
// (docs/notifications-client-integration.md 5.1/6.1). Die Route ist damit ein Vertrag: aendert die
// Webapp Pfad, Parametername oder den Wert "notifications", laufen alle bereits versendeten Mails
// ins Leere, bis der Server nachgezogen ist.
//
// Bewusst NICHT umgesetzt: eine Rueckrichtung. Ein Tab-Wechsel im Screen aendert die URL nicht —
// der Parameter ist eine Eintrittskarte, keine Tab-Steuerung. Ebenso bleibt der vom Server
// mitgeschickte lang-Parameter hier unbeachtet; er ist ein eigener Punkt.

/** Panel-Reihenfolge in user-profile.component.html. */
export const PROFILE_TAB_INDEX = {
  general: 0,
  roles: 1,
  notifications: 2
} as const;

/** Der Name des Query-Parameters — Teil des Server-Vertrags, nicht frei waehlbar. */
export const PROFILE_TAB_QUERY_PARAM = 'tab';

/**
 * Der Wert, der den Benachrichtigungs-Tab oeffnet — ebenfalls Teil des Vertrags. Steht hier, damit
 * ihn auch die Glocke und die Seite /notifications fuer ihr Zahnrad verwenden koennen, ohne den
 * String zu wiederholen (#736).
 */
export const PROFILE_TAB_NOTIFICATIONS = 'notifications';

/**
 * Uebersetzt den Query-Parameter in den Panel-Index.
 *
 * Ausgewertet wird ausschliesslich der Wert "notifications". Alles andere — ein anderer Tabname,
 * ein Zahlwert, abweichende Gross-/Kleinschreibung oder ein fehlender Parameter — landet auf dem
 * ersten Tab. Ein unbekannter Wert ist damit nie ein Fehlerfall, sondern ein normaler Profilaufruf.
 */
export function profileTabIndexFor(tab: string | null | undefined): number {
  return tab === PROFILE_TAB_NOTIFICATIONS
    ? PROFILE_TAB_INDEX.notifications
    : PROFILE_TAB_INDEX.general;
}
